export default __webpack_public_path__ + "static/media/preguntas-banner.41a11f0b.png";